const Form067TC = {
    // form: "有關資助小學高於核準職級的校長／降職主任級教師特別支薪安排申請表",
    form: "有關資助小學高於核准職級的校長／降職主任級教師\n{{schoolYear}}學年特別支薪安排申請",
    errorMsg: {
        "E-0106": "AA000000(A)",
        "E-0105": "請輸入一個有效的英文姓名",
        "E-0104": "請輸入一個有效的中文姓名",
        "E-0103": "請輸入29-41的範圍",
        "E-0102": "請輸入25-41的範圍",
        "E-0101": "請輸入正確數字",
        "E-0100": "請輸入0-49的範圍",
        "E-0111": "請輸入0-49的範圍",
        "E-0099": "請輸入0-49的範圍",
        "E-0107": "降職／晉升前後的職級不能相同",
        schoolYear:
            "請輸入一個有效的建議學年 (20XX/XX)，而該學年不應是本學年或之前",
        firstSchoolYearError:
            "請輸入一個有效的建議學年 (20XX/XX)，而該學年不應是本學年或之後",
        E01: "職級不能相同",
        reason: "請輸入一個有效的註明",
        schoolYearError: "擬議學年不應為上一學年",
        tooltip10: "薪金（總薪級表薪點）不應大於頂薪點（總薪級表薪點）",
    },

    stepName: {
        ImportantNotes: "重要事項",
        action: "行動",
        note: "註意",
        information: "基本資料",
        payPointForOverRankedStaff: "高於核准職級的教職員的支薪點",
        certification: "聲明",
        confirmation: "確認",
    },
    businessTypes: {},
    label: {
        ImportantNotesContent: {
            title: "個人資料收集聲明",
            p_title: "收集個人資料的目的",
            p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
            p1_a: "處理、核實及查證就資助學校高於核准職級的校長／降職教師或實驗室技術員作特別支薪安排的申請；",
            p1_b: "就上文(a)項所述申請的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
            p1_c: "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
            p1_d: "培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
            p1_e: "處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計；",
            p1_f: "編製統計資料、研究及政府刊物；以及",
            p1_g: "執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》]。",

            p2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理有關申請。",

            p_title3: "可獲轉移資料者",
            p3_1: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
            p3_a: "政府其他政策局及部門，以用於上文第1段所述的用途；",
            p3_b: "與本表格相關的學校，以用於上文第1段所述的用途；",
            p3_c: "你曾就披露個人資料給予訂明同意；以及；",
            p3_d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",

            p_title4: "查閱個人資料",
            p4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向有關高級學校發展主任提出，並寄交教育局網頁(<a href='https://www.edb.gov.hk/tc/contact-us/reo.html' target='_blank'>https://www.edb.gov.hk/tc/contact-us/reo.html</a>)所載區域教育服務處地址或電郵至 <a href='mailto: edbinfo@edb.gov.hk'>edbinfo@edb.gov.hk</a>。",
            // p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
        },
        csdoBeforeText: "致﹕教育局總學校發展主任",
        // csdoBeforeText: "致：（",
        csdoBeforeTextTemp: "致：",
        csdoAfterText: "",
        csdoAfterTextTemp: "",
        certify: "本人確認：",
        applicationForm: "申請表",
        confirmation: "確認聲明",
        note: "註",
        schoolChoice: {
            ManagementCommittee: "校董會",
            Incorporated: "法團校董會",
        },
        day: {
            1: "1日",
            2: "2日",
            3: "3日",
            4: "4日",
            5: "5日",
            6: "6日",
            7: "7日",
            8: "8日",
            9: "9日",
            10: "10日",
            11: "11日",
            12: "12日",
            13: "13日",
            14: "14日",
            15: "15日",
            16: "16日",
            17: "17日",
            18: "18日",
            19: "19日",
            20: "20日",
            21: "21日",
            22: "22日",
            23: "23日",
            24: "24日",
            25: "25日",
            26: "26日",
            27: "27日",
            28: "28日",
            29: "29日",
            30: "30日",
            31: "31日",
        },
        month: {
            august: "8月",
            september: "9月",
        },
        specify: "請註明",
        ActionToBeTakenList: {
            one: "調配高於核准職級的教職員，以填補同一學校內因有教職員退休／辭職／合約屆滿而出現的空缺。",
            two: "調配高於核准職級的教職員，以填補同一學校內因<u>{{desc}}</u>而新設的對等職級職位。",
            three: "調配高於核准職級的教職員，以填補同一辦學團體轄下其他學校內因有教職員退休／辭職／合約屆滿而出現的空缺。",
            four: "調配高於核准職級的教職員，以填補同一辦學團體轄下其他學校內因<u>{{desc}}</u>而新設的對等職級職位。",
            five: "高於核准職級的教職員將會參加共享職位。",
            six: "高於核准職級的教職員將會退休／辭職。",
            seven: "其他措施：<u>{{desc}}</u>。",
            eight: "其他措施：<u>{{desc}}</u>。",
            nine: "其他措施：<u>{{desc}}</u>。",
        },
        ActionToBeTakenListTemp: {
            one: "調配高於核准職級的教職員，以填補同一學校內因有教職員退休／辭職／合約屆滿而出現的空缺。",
            two: "調配高於核准職級的教職員，以填補同一學校內因___________而新設的對等職級職位。",
            three: "調配高於核准職級的教職員，以填補同一辦學團體轄下其他學校內因有教職員退休／辭職／合約屆滿而出現的空缺。",
            four: "調配高於核准職級的教職員，以填補同一辦學團體轄下其他學校內因___________而新設的對等職級職位。",
            five: "高於核准職級的教職員將會參加共享職位。",
            six: "高於核准職級的教職員將會退休／辭職。",
            seven: "其他措施",
            eight: "其他措施",
            nine: "其他措施",
        },
        ActionToBeTakenList2: { ten: "不適用" },
        seven: "其他措施",
        eight: "其他措施",
        nine: "其他措施",

        IncrementalDateList: {
            0: "  ",
            1: "01",
            2: "02",
            3: "03",
            4: "04",
            5: "05",
            6: "06",
            7: "07",
            8: "08",
            9: "09",
            10: "10",
            11: "11",
            12: "12",
        },
        CSDOTypes: {
            // NORTH: "北區",
            // KWAITSING: "葵青區",
            // SAIKUNG: "西貢區",
            // EASTERN: "東區",
            // TUENMUN: "屯門區",
            // KOWLOONCITY: "九龍城區",
            // KWUNTONG: "觀塘區",
            // SOUTHERN: "南區",
            // YAUTSIMMONG: "油尖旺區",
            // TSUENWAN: "荃灣區",
            // SHATIN: "沙田區",
            // SHAMSHUIPO: "深水埗區",
            // TAIPO: "大埔區",
            // WANCHAI: "灣仔區",
            // ISLANDS: "離島區",
            // CENTRALANDWESTERN: "中西區",
            // YUENLONG: "元朗區",
            // WONGTAISIN: "黃大仙區",
            Central_and_Western: "中西區",
            Southern: "南區",
            Wan_Chai: "灣仔區",
            Islands: "離島區",
            HKEast: "港島東區",
            Kowloon_City: "九龍城區",
            Sham_Shui_Po: "深水埗區",
            Sai_Kung: "西貢區",
            Kwun_Tong: "觀塘區",
            Wong_Tai_Sin: "黃大仙區",
            Yau_Tsim_Mong: "油尖旺區",
            Tai_Po: "大埔區",
            North: "北區",
            Sha_Tin: "沙田區",
            Kwai_Chung_and_Tsing_Yi: "葵青區",
            Tsuen_Wan: "荃灣區",
            Tuen_Mun: "屯門區",
            Yuen_Long: "元朗區",
        },
        conditions: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        iamSignCheck: "本人明白此電子表格需要使用｢智方便+｣的數碼簽署功能。",
        noteList: {
            noteOne:
                "在使用本網站之前，請閱讀以下條款和條件。使用本網站即表示您同意遵守以下條款和條件。",
            noteTwo:
                "請提交電子表格或紙質表格，請注意，如果提交了重複的申請，處理過程可能會受影響。",
            noteThree:
                "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
            note1: "1:請刪去不適用者。",
            note2: "2:降職教職員的支薪點如尚未達到降職後所屬職級的頂薪點，可按照降職後所屬職級的薪級表繼續增薪。",
            note3: "3:不包括責任津貼（如有）。",
            note4: "4:如須降職的主任級教師的職級超出基本職級多於一級(例如高級小學學位教師 )，而學校並無職位空缺讓該主任級教師只降低一級，則學校有酌情權，決定是否把該主任級教師降職多於一級，或安排多於一位主任級教師進行一連串降職 ，直到不超出核准編制為止。學校必須有充分理據支持所作的決定，亦應設立上訴機制。有關的安排應讓校內全體教師知悉，並妥為記錄，以便日後如被指處事不公平或不適當，可作證明之用。",
            note5: "5:不再合資格領取以前可享有的責任津貼(如有)，因此，責任津貼不包括在內。",
            note6: "6:只適用於降職教職員，但其支薪點尚未超越降職後所屬職級的頂薪點。",
            note7: "7:請參考附件並填寫代號。",
            note8: "8:如果該學年不是2021/22學年,學校還應附加一個計劃關於如何糾正的情況,列出預期的空置情況推廣躋身在同樣的學校贊助機構（如適用）在未來學校年。",

            // note0: "本人確認:",
            // notea: "（a）已參照教育局通函第34/2020號所載有關揀選超額教師的安排；",
            // noteb: "（b）已通知降職教職員有關上述特殊的臨時安排；",
            // notec: "（c）本表格內所載的資料包括修正計劃均屬正確無誤；",
            // noted: "（d）須降職的教職員在2020/21學年的職務，會盡量與其薪酬相稱；以及",
            // notee: "（e）本校會把任何多付的薪金津貼退還教育局。",
            // notef: "1 至 6 項所列舉的措施僅供學校參考，並非盡錄無遺。校方請於 7 至 9 項內註明其他建議措施，以有效修正高於核准職級的情況。",
            notef: "請參考附件並填寫代號。",
            ImportantNotes: "個人資料收集聲明",
            title: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
            a: "辦理與聘用有關的事宜；",
            b: "處理發放薪金津貼及其他政府資助；",
            c: "計算公積金的供款；",
            d: "進行核數工作；",
            e: "進行研究及統計資料，以便規劃教育服務；",
            f: "處理有關教育專業人員發展的事宜；",
            g: "執行相關《資助則例》、《教育條例》、《教育規例》及《補助/津貼學校公積金規則》的規定。",
            title1: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
            title2: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
            title3: "根據《個人資料(私隱)條例》，第 18 和 22 條及附表 1 保障資料第 6 原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
            title4: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",

            cera: "已參照教育局通函{{circularNumber}}所載有關揀選超額教師的安排；",
            cerb: "已通知降職教職員有關上述",
            cerb1: "特殊的臨時安排",
            cerb2: "；",
            cerc: "本表格內所載的資料包括修正計劃均屬正確無誤；",
            cerd: "須降職的教職員在{{schoolYear}}學年的職務，會盡量與其薪酬相稱；以及",
            cere: "本校會把任何多付的薪金津貼退還教育局。",
        },
        rankList: {
            // AM: "AM",
            // SAM: "SAM",
            // PAM: "PAM",
            // PSM: "PSM",
            // SPSM: "SPSM",
            // HMI: "HMI",
            // HMII: "HMII",

            // LTI: "LTI",
            // AM: "AM",
            // SAM: "SAM",
            // PAM: "PAM",
            // SGM: "SGM",
            // PGM: "PGM",
            // PII: "PII",
            // PI: "PI",

            CM: "CM",
            APSM: "APSM",
            AM: "AM",
            SAM: "SAM",
            PAM: "PAM",
            PSM: "PSM",
            SPSM: "SPSM",
            HMII: "HMII",
            HMI: "HMI",
        },
        // rectificationPlan: "修正高於核准職級情況的計劃",
        rectificationPlan: "修正計劃",
    },
    note: {
        note1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途：",
        a: "辦理與聘用有關的事宜；",
        b: "處理發放薪金津貼及其他政府資助；",
        c: "計算公積金的供款；",
        d: "進行核數工作；",
        e: "進行研究及統計資料，以便規劃教育服務；",
        f: "處理有關教育專業人員發展的事宜；",
        g: "執行相關《資助則例》、《教育條例》、《教育規例》及《補助/津貼學校公積金規則》的規定。",
        note22: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        note23: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        note24: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        note25: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向有關高級學校發展主任提出。",
    },

    information: {
        csdo: "總學校發展主任",
        date: "日期",
        managementCommittee: " 校董會／法團校董會：",
        formHeaderTitle: "職員{{index}}",
        record: {
            1: "一",
            2: "二",
            3: "三",
        },
        code: "編號",
        hkidNo: "身份證號碼",
        englishName: "英文姓名",
        chineseName: "中文姓名",
        firstSchoolYear:
            "如{{year}}年8月31日或之前已降職，填上<u><b>首次</b></u>獲批特別支薪安排的學年",

        ranks: "職級",
        salary: "薪金（總薪級表薪點）",
        salaryBar: "薪酬關限（總薪級表薪點）",
        maxSalary: "頂薪點（總薪級表薪點）",
        incrementalDate: "增薪日期（01/月份）",
        effectiveDateFrom: "生效日期由",
        effectiveDateTo: "生效日期至",

        rank: "職級",
        salarys: "薪金（總薪級表薪點）",
        salaryBars: "薪酬關限（總薪級表薪點）",
        maxSalarys: "頂薪點（總薪級表薪點）",
        // incrementalDates: "增薪日期（01/月份）",
        dateOfNextIncrement: "下次增薪日期",
        // actionToBeTaken: "在{{schoolYearNext}}或其後學年採取的措施",
        actionToBeTaken: "措施",
        proposedSchoolYear: "建議學年",

        Notes1: "在{{year}}年8月31日當日",
        EffectiveDateFromBeforeText: "由",
        EffectiveDateFromAfterText: "至",
        EffectiveDateToAfterText: "降職後生效（如有需要，請修改上述期間）。",
        Notes2: "由{{from}}至{{to}}",
        Notes2Temp: "降職後生效",
        Note: {
            Note1: "請刪去不適用者。",
            Note2: "降職教職員的支薪點如尚未達到降職後所屬職級的頂薪點，可按照降職後所屬職級的薪級表繼續增薪 。",
            Note3: "不包括責任津貼 （如有）。",
            Note4: "如須降職的主任級教師的職級超出基本職級<u>多於一級</u>（例如高級小學學位教師），而學校並無職位空缺讓該主任級教師只降低一級，則學校有酌情權，決定是否把該主任級教師降職多於一級，或安排多於一位主任級教師進行一連串降職，直到不超出核准編制為止。學校必須有充分理據支持所作的決定，亦應設立上訴機制。有關的安排應讓校內全體教師知悉，並妥為記錄，以便日後如被指處事不公平或不適當，可作證明之用。",
            Note5: "不再合資格領取以前可享有的責任津貼（如有），因此，責任津貼不包括在內",
            Note6: "只適用於支薪點尚未超越降職後所屬職級頂薪點的教職員。如非前述情況，應填上“不適用”，降職教職員僅在貴校回復至降職前的職級後，才會按原來職級的薪級表獲發增薪點。",
            Note7: "請參考附件並填寫代號",
        },

        beforeDateText: "教育局{{year}}",
        afterDateText: "的來信已經收到。本校",
        management: "校董會／法團校董會",
        beforeNote1Text:
            "為下列高於核准職級的教職員（包括{{year}}年9月1日前高於核准職級的校長及／或降職主任級教師），向教育局申請在{{schoolYear}}學年保留其在{{year}}年8月31日的",
        afterNote1Text: "",
        noteLabel1: "",
        noteLabel2: "支薪點",
        afterNote2Text: "。",
        attachment: "補充文件",
        lastSchoolEmployment: "最後任職之學校",
        primaryOrSecondaryOption: {
            primary: "小學",
            secondary: "中學",
        },
    },
    SalaryList: {
        // 0: "12,915",
        // 1: "13,735",
        // 2: "14,600",
        // 3: "15,560",
        // 4: "16,565",
        // 5: "17,675",
        // 6: "18,795",
        // 7: "20,035",
        // 8: "21,340",
        // 9: "22,725",

        // 10: "24,070",
        // 11: "25,545",
        // 12: "27,145",
        // 13: "28,780",
        // 14: "30,235",
        // 15: "31,750",
        // 16: "33,350",
        // 17: "35,040",
        // 18: "36,765",
        // 19: "38,595",

        // 20: "40,515",
        // 21: "42,545",
        // 22: "44,555",
        // 23: "46,655",
        // 24: "48,860",
        25: "51,095",
        26: "53,500",
        27: "55,995",
        28: "58,635",
        29: "61,415",

        30: "64,270",
        31: "67,295",
        32: "70,465",
        33: "73,775",
        34: "74,515",
        35: "75,265",
        36: "78,385",
        37: "82,105",
        38: "85,870",
        39: "89,845",

        40: "93,710",
        41: "97,745",
        // 42: "101,965",
        // 43: "106,340",
        // 44: "110,170",
        // 45: "117,580",
        // 46: "121,790",
        // 47: "126,220",
        // 48: "130,760",
        // 49: "135,470",
    },
    tooltipList: {
        tooltip1: "請刪去不適用者。",
        tooltip2:
            "降職教職員的支薪點如尚未達到降職後所屬職級的頂薪點，可按照降職後所屬職級的薪級表繼續增薪。",
        tooltip3:
            "只適用曾獲批特別支薪安排的教職員。如相關教職員於{{schoolyear}}學年降職並首次申請特別支薪安排，應填上“不適用”。",
        tooltip4: "不包括責任津貼（如有）。",
        tooltip5:
            "如須降職的主任級教師的職級超出基本職級多於一級（例如高級小學學位教師），而學校並無職位空缺讓該主任級教師只降低一級，則學校有酌情權，決定是否把該主任級教師降職多於一級，或安排多於一位主任級教師進行一連串降職，直到不超出核准編制為止。學校必須有充分理據支持所作的決定，亦應設立上訴機制。有關的安排應讓校內全體教師知悉，並妥為記錄，以便日後如被指處事不公平或不適當，可作證明之用。",
        tooltip6:
            "不再合資格領取以前可享有的責任津貼（如有），因此，責任津貼不包括在內。",
        tooltip7:
            "只適用於支薪點尚未超越降職後所屬職級頂薪點的教職員。如非前述情況，應填上“不適用”，降職教職員僅在貴校回復至降職前的職級後，才會按原來職級的薪級表獲發增薪點。",
        tooltip8: "請參考附件並填寫代號。",
    },
};
export default Form067TC;
